import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../../CompleteInspectionContext';
import {formattingDate} from '../../../../utils/formatting';
import {getDocCodeString} from "../../../../utils/texts";
import styles from './styles.module.scss';
import {propertyTypesGroups as PT} from "../../../../../Inspection/constants/propertyTypesGroups";

const DocProps = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {
    gush, helka, ttHelka,
    pdfCreateTime,
    bankName,
    bankBranchNumber,
    bankBranchName,
    bankClerkFullName,
    bankEmail,
    bankRequestID,
    bankBuildType,
    loanSubTypeName,
    propertyTypeID
  } = context.data.pdfData;

  const pdfCreateTimeValue = formattingDate(pdfCreateTime);
  const docCodeValue = getDocCodeString({gush, helka, ttHelka, pdfCreateTime});
  const bankBranchNameValue = Boolean(bankBranchName) ? bankBranchName : '';
  const bankBranchNumberValue = Boolean(bankBranchNumber) ? bankBranchNumber : '';
  const branchValue = `${bankBranchNameValue} ${bankBranchNumberValue}`;

  const getPropertyTypeItem = () => {
    const isPropertyTypeRegular = PT.REGULAR.includes(propertyTypeID);

    return isPropertyTypeRegular
      ? (
        <div className={styles.docPropsItem}>
          <div className={styles.underline}>סוג בניה בהתאם להנחיות משרד השיכון: </div>
          <div>בנייה רוויה</div>
        </div>
      ) : null;
  };

  return (
    <div ref={ref}>
      <div className={classnames(styles.docPropsItem, styles.sectionPadding)}>
        לכבוד:
      </div>
      <div className={styles.docProps}>
        <div className={styles.rightSideRows}>
          <div className={classnames(styles.bold, styles.bigColumn, styles.docPropsItem)}>
            {bankName}
          </div>
          {(Boolean(bankBranchName) || Boolean(bankBranchNumber)) && (
            <div className={classnames(styles.bigColumn, styles.docPropsItem)}>
              סניף:{branchValue}
            </div>
          )}
          {Boolean(bankClerkFullName) && (
            <div className={classnames(styles.bigColumn, styles.docPropsItem)}>
              לידי:{bankClerkFullName}
            </div>
          )}
          {Boolean(bankEmail) && (
            <div className={classnames(styles.bigColumn, styles.docPropsItem)}>
              מייל: {bankEmail}
            </div>
          )}
        </div>
        <div className={styles.leftSideRows}>
          <div className={classnames(styles.bold, styles.docPropsItem)}>
            תאריך: {pdfCreateTimeValue}
          </div>
          <div className={classnames(styles.bold, styles.docPropsItem)}>
            סימננו:{docCodeValue}
          </div>
          {Boolean(bankRequestID) && (
            <div className={classnames(styles.bold, styles.docPropsItem)}>
              מספר בקשה/הלוואה/בטחון:{bankRequestID}
            </div>
          )}
          {Boolean(loanSubTypeName) && (
            <div className={styles.docPropsItem}>
              סוג הלוואה:  {loanSubTypeName}
            </div>
          )}
          {getPropertyTypeItem()}
          {Boolean(bankBuildType) && (
            <div className={styles.docPropsItem}>
              צפיפות לדונם:  {bankBuildType}
            </div>
          )}
        </div>
      </div>
      <div className={classnames(styles.bold, styles.lastPageLine, styles.innerPadding)}>
        ג.א.נ. ,
      </div>
    </div>
  );
});

export default DocProps;
